import DocumentType from '@/types/documents/documentType'
import { BaseService } from './../../base'
export class DocumentTypeService extends BaseService<DocumentType>() {
    static get entity (): string {
        return 'document_type'
    }
    static get responseName (): string {
        return 'document_type'
    }
}